"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GermanNumberFormat = _interopRequireDefault(require("./GermanNumberFormat"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _GermanNumberFormat["default"];
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9OdW1iZXJVdGlsL2luZGV4LnRzIl0sIm5hbWVzIjpbIkdlcm1hbk51bWJlckZvcm1hdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O2VBRWVBLDhCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IEdlcm1hbk51bWJlckZvcm1hdCBmcm9tICcuL0dlcm1hbk51bWJlckZvcm1hdCc7XG5cbmV4cG9ydCBkZWZhdWx0IEdlcm1hbk51bWJlckZvcm1hdDtcbiJdfQ==